import axios from "axios";
import { writable } from "svelte/store";
import type { ApiClient } from "@hitit/api";

import profileImageFallback from "../assets/profile.png";

function createProfileImage() {
	const { subscribe, update } = writable<string>(profileImageFallback);

	async function refreshProfileImage(
		apiClient: ApiClient,
		id: string,
		fileData?: unknown
	) {
		async function _refreshProfileImage() {
			let imageData: any = fileData;

			if (!fileData) {
				const url = `${"HITIT_IMAGE_URL"}profile/${id}.png?v=${Date.now()}`;
				const r = await axios.get(url, {
					withCredentials: true,
					responseType: "blob",
				});
				console.log("r",r)
				imageData = r.data;
			}

			update((oldUrl) => {
				if (oldUrl) URL.revokeObjectURL(oldUrl);
				return URL.createObjectURL(imageData);
			});
		}

		try {
			await _refreshProfileImage();
		} catch (e) {
			await apiClient.getAllSignedCookies();
			await _refreshProfileImage();
		}
	}

	function setDefaultImage() {
		update((oldUrl) => {
			if (oldUrl) URL.revokeObjectURL(oldUrl);
			return profileImageFallback
		})
	}

	return {
		subscribe,
		refreshProfileImage,
		setDefaultImage
	};
}

export const profileImage = createProfileImage();

